import { Tag, type TagProps } from "antd";
import React from "react";
import { useAgentLevelInfo } from "@/utils/agentLevel";

export interface AgentLevelTagProps extends TagProps {
  level: number | undefined;
}

/**
 * 统一的代理层级标签组件
 */
const AgentLevelTag: React.FC<AgentLevelTagProps> = ({ level, ...rest }) => {
  const getLevelInfo = useAgentLevelInfo();
  const info = getLevelInfo(level);

  if (!level) return null;

  return (
    <Tag color={info.color} {...rest}>
      {info.label}
    </Tag>
  );
};

export default AgentLevelTag;
